import type { Cell, NewCell } from '@/models/Cell';
import CoreApi from '@/api/CoreApi';

export async function loadCells(): Promise<Cell[]> {
  const response = await CoreApi.axiosClient.get('/admin/cells');
  return response.data;
}

export async function createCell(newCell: NewCell): Promise<Cell> {
  const response = await CoreApi.axiosClient.post('/admin/cells', newCell);
  return response.data;
}

export async function patchCell(cellToPatch: Cell): Promise<Cell> {
  const response = await CoreApi.axiosClient.patch('/admin/cells', cellToPatch);
  return response.data;
}

export async function deleteCell(cellToDelete: Cell): Promise<void> {
  await CoreApi.axiosClient.delete(`/admin/cells/${cellToDelete.uuid}`);
}
